/**
 * K Addition Within 5 Practice Types
 *
 * Addition facts within 5 where operand1 <= operand2 and sum <= 5.
 * Facts: FACT1685-FACT1696 map to 12 addition problems.
 */

export interface AdditionFact {
  operand1: number;
  operand2: number;
  sum: number;
}

// All valid addition facts within 5 (operand1 <= operand2, sum <= 5)
export const ADDITION_FACTS: AdditionFact[] = [
  { operand1: 0, operand2: 0, sum: 0 },  // FACT1685
  { operand1: 0, operand2: 1, sum: 1 },  // FACT1686
  { operand1: 0, operand2: 2, sum: 2 },  // FACT1687
  { operand1: 0, operand2: 3, sum: 3 },  // FACT1688
  { operand1: 0, operand2: 4, sum: 4 },  // FACT1689
  { operand1: 0, operand2: 5, sum: 5 },  // FACT1690
  { operand1: 1, operand2: 1, sum: 2 },  // FACT1691
  { operand1: 1, operand2: 2, sum: 3 },  // FACT1692
  { operand1: 1, operand2: 3, sum: 4 },  // FACT1693
  { operand1: 1, operand2: 4, sum: 5 },  // FACT1694
  { operand1: 2, operand2: 2, sum: 4 },  // FACT1695
  { operand1: 2, operand2: 3, sum: 5 },  // FACT1696
];

export interface AdditionPracticeProgress {
  factId: string;
  factIndex: number;
  attempts: number;
  correct: number;
  isComplete: boolean;
}

// Standard interface used by practice screens
export interface AdditionFactWithId {
  factId: string;
  factIndex: number;  // Index into ADDITION_FACTS array (0-11)
}
